// extracted by mini-css-extract-plugin
export default {"root":"PlasmicDashboardNotPaidStatusCard_root__FSeIB","text":"PlasmicDashboardNotPaidStatusCard_text__zFIKS"};